module.exports = __webpack_public_path__ + "img/checkbox-deselected.6d430ed5.svg";